/** 지역 트리 조회 용도. */
export const RegionScopes = {
  DEFAULT: "DEFAULT",
  ANALYSIS: "ANALYSIS",
};
